<div class="loja-em-criacao">
  <main class="cartao">
    <header class="identidade">
      <img class="logo" *ngIf="empresa?.logo; else inicial" [src]="'/images/empresa/' + empresa.logo" alt=""/>
      <ng-template #inicial>
        <span class="logo inicial">{{ (empresa?.nome || '?').charAt(0) }}</span>
      </ng-template>
      <span class="nome">{{ empresa?.nome }}</span>
    </header>

    <span class="selo">Em preparação</span>
    <h1>Esta loja ainda está sendo preparada</h1>
    <p class="texto">
      O cardápio e as formas de entrega ainda estão sendo configurados.
      Volte em breve para fazer seu pedido.
    </p>

    <section class="dono">
      <h2>É o dono da loja?</h2>
      <p class="texto">
        Faltam alguns ajustes para a loja abrir. Continue a configuração com a Mia no WhatsApp,
        na mesma conversa em que a loja foi criada, ou termine pelo painel.
      </p>

      <p class="alerta" *ngIf="requerAtencao">
        A configuração parou em um ponto que precisa de revisão. Fale com a Mia ou com o nosso suporte para continuar.
      </p>

      <ol class="etapas">
        <li *ngFor="let etapa of etapas" [class]="classe(etapa.situacao)">
          <span class="marcador" aria-hidden="true">
            <svg *ngIf="classe(etapa.situacao) === 'concluido'" viewBox="0 0 16 16" width="12" height="12">
              <path d="M3.5 8.5l3 3 6-7" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <span class="descricao">
            <strong>{{ etapa.titulo }}</strong>
            <small>{{ etapa.descricao }}</small>
          </span>
          <span class="situacao">{{ rotulo(etapa.situacao) }}</span>
        </li>
      </ol>

      <a class="botao" href="/admin/login">Abrir o painel</a>
    </section>
  </main>
</div>
